// angular import
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Location, LocationStrategy } from '@angular/common';

// project import
import { NavigationItem, NavigationItems } from '../navigation';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-nav-content',
  templateUrl: './nav-content.component.html',
  styleUrls: ['./nav-content.component.scss']
})
export class NavContentComponent implements OnInit {
  // version
  title = 'Demo application for version numbering';
  // currentApplicationVersion = environment.appVersion;

  // public pops
  navigations: NavigationItem[];
  wrapperWidth!: number;
  windowWidth: number;
  moduleList : any =[]

  @Output() NavMobCollapse = new EventEmitter();
  // constructor
  constructor(
    private location: Location,
    private locationStrategy: LocationStrategy
  ) {
    this.windowWidth = window.innerWidth;
    this.navigations = NavigationItems;
  }

  // life cycle event
  ngOnInit() {
    if (this.windowWidth < 992) {
      document.querySelector('.pcoded-navbar')?.classList.add('menupos-static');
    }
    if(localStorage.getItem('moduleList'))
    {
      this.moduleList= JSON.parse(localStorage.getItem('moduleList') ?? '')
      this.navigations.map((m:any)=>{
        let parentPermission = false;
        if(m.children?.length){
          if(!m.children[0].children){
            if(this.moduleList.filter((item:any) => item.menuName == m.children[0].title).length > 0) {
              m.children[0].isPermission = true;
              m.children[0].name = this.moduleList.filter((item:any) => item.menuName == m.children[0].title)?.[0]?.name;
              parentPermission = true;
            }
            else
              m.children[0].isPermission = false;
          }
          else
          {
            m.children[0].children.map((sm:any) =>{
              if(this.moduleList.filter((item:any) => item.menuName == sm.title && item.parentModuleName == m.children[0].title).length > 0)
              {
                sm.isPermission = true;
                sm.name = this.moduleList.filter((item:any) => item.menuName == sm.title)?.[0]?.name
                parentPermission = true;
              }
              else
                sm.isPermission = false;
            })
          }
        }
        m.isPermission = parentPermission;
      })
    }

  }

  // public method

  navMob() {
    if (this.windowWidth < 992 && document.querySelector('app-navigation.pcoded-navbar')?.classList.contains('mob-open')) {
      this.NavMobCollapse.emit();
    }
  }

  fireOutClick() {
    let current_url = this.location.path();
    const baseHref = this.locationStrategy.getBaseHref();
    if (baseHref) {
      current_url = baseHref + this.location.path();
    }
    const link = "a.nav-link[ href='" + current_url + "' ]";
    const ele = document.querySelector(link);
    if (ele !== null && ele !== undefined) {
      const parent = ele.parentElement;
      const up_parent = parent?.parentElement?.parentElement;
      const last_parent = up_parent?.parentElement;
      if (parent?.classList.contains('pcoded-hasmenu')) {
        parent.classList.add('pcoded-trigger');
        parent.classList.add('active');
      } else if (up_parent?.classList.contains('pcoded-hasmenu')) {
        up_parent.classList.add('pcoded-trigger');
        up_parent.classList.add('active');
      } else if (last_parent?.classList.contains('pcoded-hasmenu')) {
        last_parent.classList.add('pcoded-trigger');
        last_parent.classList.add('active');
      }
    }
  }
}
